import { Link } from "react-router-dom";

const UtilBar = () => (
  <div id="showroom" className="bg-neutral-950">
    <div className="px-4 md:px-12 py-1.5 md:py-2 flex flex-col md:flex-row justify-between items-center text-[10px] md:text-[11px] font-normal tracking-wide text-primary-foreground/[.45] gap-1">
      <a
        href="https://www.google.com/maps/dir/?api=1&destination=1+Wood+Floors+33475+W+7+Mile+Rd+Livonia+MI+48152"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-primary-foreground transition-colors py-2 px-1"
      >
        📍 Visit our Livonia Design Center: 33475 West Seven Mile Road, Livonia, MI 48152
      </a>
      <a
        href="https://www.google.com/maps/dir/?api=1&destination=1+Wood+Floors+33475+W+7+Mile+Rd+Livonia+MI+48152"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-primary text-primary-foreground px-4 py-2 rounded-full text-[10px] md:text-[11px] font-medium hover:bg-gold-400 transition-colors whitespace-nowrap"
      >
        Get directions
      </a>
      <a href="tel:2483258853" className="text-gold-300 font-medium hover:text-primary-foreground transition-colors py-2 px-1">
        📞 (248) 325-8853
      </a>
    </div>
    <div className="px-4 md:px-12 pb-3">
      <Link
        to="/projects/livonia-subfloor"
        className="group flex items-center gap-4 max-w-[1200px] mx-auto rounded-[14px] border border-primary-foreground/[.08] bg-primary-foreground/[.03] p-3 hover:border-primary-foreground/20 transition-colors"
      >
        <img
          src="/images/projects/hickory-michigan-plank-fireside-8-inch-floor-dining-room-livonia-mi.jpg"
          alt="Dining room with an 8 inch engineered Michigan Plank hickory floor in Fireside, Livonia, MI"
          width={1920}
          height={1280}
          loading="lazy"
          className="w-24 h-16 md:w-28 md:h-[72px] object-cover rounded-[8px] grayscale-[20%] contrast-[1.1] group-hover:grayscale-0 transition-all duration-500 shrink-0"
        />
        <div className="min-w-0">
          <p className="text-[13px] md:text-sm font-semibold text-primary-foreground leading-snug">
            Livonia: custom 8 inch hickory with subfloor correction
          </p>
          <p className="text-[10px] md:text-[11px] text-primary-foreground/40 mt-1">
            Pictured: a 1 Wood Floors project in Livonia, MI
          </p>
        </div>
      </Link>
    </div>
  </div>
);

export default UtilBar;
